import { isServer } from './is-server';
const cache = new Map();
export function hasWidget(name) {
    var _a;
    return isServer() ? cache.has(name) : !!((_a = window.widgets) === null || _a === void 0 ? void 0 : _a[name]);
}
export function setWidget(name, widget) {
    if (isServer()) {
        cache.set(name, widget);
    }
    else {
        if (!window.widgets) {
            window.widgets = {};
        }
        window.widgets[name] = widget;
    }
}
export function getWidget(name) {
    var _a;
    return isServer() ? cache.get(name) : (_a = window.widgets) === null || _a === void 0 ? void 0 : _a[name];
}
export function removeWidget(name) {
    var _a;
    if (!isServer() && ((_a = window.widgets) === null || _a === void 0 ? void 0 : _a[name])) {
        delete window.widgets[name];
    }
    if (isServer()) {
        cache.delete(name);
    }
}
